// Colour palette used in the product
export const PRIMARY = '#346DDB';

export const GREY_BLUE_LIGHT = '#abb7ca';
export const YELLOW_XXLIGHT = '#fffbed';
export const YELLOW = '#FFD139';

export const BACKDROP_BG = 'rgba(27, 30, 33, 0.77)';
export const BACKDROP_BG_LIGHT = 'rgba(0, 0, 0, 0.05)'; // Used during animation of backdrop
export const BACKDROP_BG_TRANSPARENT = 'rgba(0, 0, 0, 0.0)';

export const teal = {
    xxxlight: '#F3FAFB',
    xxlight: '#DCEEF4',
    xlight: '#89C6DA',
    light: '#4EAAC8',
    base: '#307F98',
    dark: '#286A7F',
    xdark: '#275564',
    xxdark: '#11262D',
};

// PRIMARY
export const primary = {
    xxxlight: teal.xxxlight,
    xxlight: teal.xxlight,
    xlight: teal.xlight,
    light: teal.light,
    base: teal.base,
    dark: teal.dark,
    xdark: teal.xdark,
    xxdark: teal.xxdark,
};

// violet
export const violet = {
    xlight: '#dad4ff',
    light: '#b2a5ff',
    base: '#735cff',
    dark: '#5f45ff',
    xdark: '#442fc8',
};

// scarlet
export const scarlet = {
    xlight: '#ffcccb',
    light: '#ff918f',
    base: '#d33d3d',
    dark: '#cc3131',
    xdark: '#b41a1a',
};

// fuchsia
export const fuchsia = {
    xlight: '#fbe8f0',
    light: '#ef96b8',
    base: '#e44f89',
    dark: '#db3b79',
    xdark: '#c62c68',
};

// orange
export const orange = {
    xlight: '#fdc389',
    light: '#ed9f51',
    base: '#b95e04',
    dark: '#914b05',
    xdark: '#683c11',
};

// green
export const green = {
    xxlight: '#dffff0',
    xlight: '#91eabf',
    light: '#4dde98',
    base: '#008847',
    dark: '#0c693d',
    xdark: '#0b4f2f',
};

// Light mode text
export const lightModeText = {
    xlight: '#8899a8',
    light: '#5c6975',
    base: '#3b454e',
    dark: '#050505',
};

// Dark mode text
export const darkModeText = {
    xdark: '#a2a9b9',
    dark: '#cccfd4',
    base: '#eaf2f7',
    light: '#ffffff',
};

export const darkModeGreyScale = {
    xxlight: '#374151',
    xlight: '#2d323a',
    light: '#2b2e39',
    base: '#22272e',
    dark: '#181c1f',
    xdark: '#14171c',
};

export const lightModeGreyScale = {
    xxlight: '#f5f7f9',
    xlight: '#eceff1',
    light: '#e3e8ed',
    base: '#d3dce4',
    dark: '#cccfd4',
    xdark: '#454545',
};

export const lightModeSidebar = {
    base: '#333d55',
    dark: '#283143',
};

// For dark theme
export const BACKDROP_DARK_BG = 'rgba(0, 0, 0, 0.6)';
export const BACKDROP_DARK_BG_LIGHT = 'rgba(0, 0, 0, 0.1)'; // Used during animation of backdrop
export const BACKDROP_DARK_BG_TRANSPARENT = 'rgba(0, 0, 0, 0)';

// GREY SCALE
export const WHITE = '#ffffff';
export const BLACK = '#242a31';
